// UBS Program Variables
export const ubsVariables: any = {
    programTitle: "Clients of UBS Wealth Management",
    effectiveDates: "10/15/2020 - 10/15/2021",
    carrier: ["AIG Property Casualty Company", "AIG"],
    policyUrl: "../../../assets/UBS/AIG Clients of UBS Group Personal Umbrella Policy - Policy No 6839680.pdf",
    faqUrl: "../../../assets/UBS/Group Personal Excess Liability FAQ - Alliant Private Client.pdf",
    feeDisclaimer: "*All premiums are subject to 0.9% NJ Property-Liability Insurance Guaranty Association Fee (not included in below premiums).",
    displayHowMuchInsurance: false,
    EL_Items: [
        "UBS_EL_Header",
        ["UBS_EL_5M", "$5,000,000", "$1,000,000", "$865"],
        ["UBS_EL_10M", "$10,000,000", "$1,000,000", "$1,530"],
        ["UBS_EL_15M", "$15,000,000", "$1,000,000", "$3,155"],
        ["UBS_EL_20M", "$20,000,000", "$1,000,000", "$4,780"],
        ["UBS_EL_25M", "$25,000,000", "$1,000,000", "$6,405"],
        ["UBS_EL_30M", "$30,000,000", "$1,000,000", "$8,030"],
        ["UBS_EL_35M", "$35,000,000", "$1,000,000", "$9,655"],
        ["UBS_EL_40M", "$40,000,000", "$1,000,000", "$11,280"],
        ["UBS_EL_45M", "$45,000,000", "$1,000,000", "$12,905"],
        ["UBS_EL_50M", "$50,000,000", "$1,000,000", "$14,530"]
    ],
    EL_Disclaimers: [],
    UM_Items: [
        "UBS_UM_Header",
        ["UBS_UM_1M", "$1,000,000", "Included above"],
        ["UBS_UM_2M", "$2,000,000", "$100"],
        ["UBS_UM_3M", "$3,000,000", "$200"],
        ["UBS_UM_4M", "$4,000,000", "$300"],
        ["UBS_UM_5M", "$5,000,000", "$400"],
    ],
    EPLI_Items: [],
    requiredLimits: [
        [
            "<div>Homeowners Personal Liability:</div><div>Bodily injury, property damage, and personal injury, for all property owned or rented</div>",
            "$300,000 Combined Single Limit"
        ],
        [
            "<div>Personal Automobile Liability:</div><div>Private passenger autos, motor homes, motorcycles and other motor vehicles with less than four wheels (subject to registration)</div>",
            `<div>$250,000 per person / $500,000 each occurrence bodily injury /</div>
            <div>$100,000 property damage</div>
            <div><strong>OR</strong></div>
            <div>$300,000 Combined Single Limit</div>`
        ],
        [
            "<div>Recreational Vehicle:</div><div>(not subject to registration)</div>",
            "$300,000 Combined Single Limit"
        ],
        [
            "<div>Uninsured / Underinsured Motorist Protection:</div>",
            `<div>$250,000 per person / $500,000 each occurrence bodily injury /</div>
            <div>$100,000 property damage</div>
            <div><strong>OR</strong></div>
            <div>$300,000 each occurrence Combined Single Limit</div>`
        ],
        [
            "<div>Watercraft Liability:</div><div>Under 26 feet <strong>OR</strong> under 50 horsepower</div>",
            "$300,000 Combined Single Limit"
        ],
        [
            "<div>Watercraft Liability:</div><div>26 feet or longer <strong>OR</strong> more than 50 horsepower</div>",
            "$500,000 Combined Single Limit"
        ],
        [
            "Employers Liability:",
            "$100,000 Combined Single Limit"
        ]
    ],
    CI_Items: [
        "5590",
        "5591",
        "5592"
    ],
    learnMoreUrl: "../../../assets/UBS/Complimentary Personal Insurance Review_UBS.pdf"
};

